// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vPuK","badges":"styles_badges__1AmoU"};